import { useTranslation } from 'react-i18next';
import { AlertTriangle, Check, CloudOff, Loader2, TimerOff } from 'lucide-react';
import type { SaveStatus } from '@/hooks/useAutoSave';
import { cn } from '@/lib/utils';

/**
 * ผู้เข้าอบรมมักกังวลว่าคำตอบหายไหม — ตัวบ่งชี้นี้ต้องเห็นตลอดเวลา
 * ใช้ทั้งไอคอนและข้อความ ไม่สื่อด้วยสีอย่างเดียว
 */
export function SaveIndicator({ status }: { status: SaveStatus }) {
  const { t } = useTranslation();

  const config: Record<SaveStatus, { icon: typeof Check; className: string; label: string }> = {
    saved: { icon: Check, className: 'text-emerald-700', label: t('exam.save.saved') },
    saving: { icon: Loader2, className: 'text-slate-600', label: t('exam.save.saving') },
    pending: { icon: AlertTriangle, className: 'text-amber-700', label: t('exam.save.pending') },
    offline: { icon: CloudOff, className: 'text-amber-800', label: t('exam.save.offline') },
    expired: { icon: TimerOff, className: 'text-red-700', label: t('exam.save.expired') },
  };

  const { icon: Icon, className, label } = config[status];

  return (
    <p aria-live="polite" className={cn('flex items-center gap-1.5 text-sm font-medium', className)}>
      <Icon aria-hidden className={cn('h-4 w-4', status === 'saving' && 'animate-spin')} />
      {label}
    </p>
  );
}
